import styled from "styled-components"
import { SkeletonLoaderButton, SkeletonLoaderText } from "_shared/styles/skeletonLoader";

export const HeaderContainer = styled.div`
    display: flex;
    padding: 20px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;


export const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const MarketName = styled(SkeletonLoaderText)`
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    ${({ isLoading }) => isLoading && 'margin-bottom: 10px;'}
`;

export const Description = styled(SkeletonLoaderText)`
    margin: 0;
    font-size: 16px;
`;


export const HeadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 10px;
`;


export const ActionButton = styled(SkeletonLoaderButton)`
    
`;

export const BoostAutoButton = styled(SkeletonLoaderButton)`
    ${({ isLoading }) => !isLoading && 'border: 1px solid #323232;'}
`;

export const ButtonsContainer = styled.div`
    display: inline-flex;
    gap: 10px;
`;	
